import { isDeliverySurchargeAddon } from '@common/utils/is-delivery-surcharge-addon/is-delivery-surcharge-addon.util';

export const isFeeOnlyAddon = (id: string | undefined): boolean => {
    return !!id?.includes('_delivery_fee');
};

export const isFeeAddon = (id: string | undefined): boolean => {
    return isFeeOnlyAddon(id) || isDeliverySurchargeAddon(id);
};
